/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const periodMeasureUnitEnumSchema = z.enum(["month", "day", "hour"]).describe("* `month` - Месяц\n* `day` - День\n* `hour` - Час");
